import { create } from "zustand";
import { immer } from "zustand/middleware/immer";

// ⬇️ not exported, so that one cannot subscribe to the entire store

const useReportStore = create(immer(set => ({

    mfgReportPlates: [],

    actions: {
        setMfgViewReportPlates: (data) => set(state => { state.mfgReportPlates = data }),
    }
})));

// 💡 exported - consumers don't need to write selector
export const useMfgViewReportPlates = () => useReportStore((state) => state.mfgReportPlates);
//one selector for all our actions, destructure in the components
export const useReportActions = () => useReportStore((state) => state.actions);

